import {useContext} from 'react';
import {CalculatorInputFieldsKey, CalculatorInputOptions,} from '../utils/CalculatorInputValue';
import {CalculatorFieldsContext} from '../contexts/CalculatorContext';
import {CalculatorCurrencyContext} from '../../../shared/contexts/CalculatorContext';

export function CalculatorRembursement(): JSX.Element | null {
    const [calculatorValue,] = useContext(CalculatorFieldsContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const options = CalculatorInputOptions['avg_reimbursement_per_exams_medical_devices'];
    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    let selected = '';

    const getValue = (key: CalculatorInputFieldsKey): number => {
        return calculatorValue[key] || 0;
    }

    const keys: CalculatorInputFieldsKey[] = [
        'high_examination_mix_percent',
        'medium_examination_mix_percent',
        'low_examination_mix_percent'
    ];

    if (keys.reduce((prev, curr) => prev + (+(calculatorValue[curr] || 0)), 0) === 1) {
        const value = (getValue('high_examination_mix_percent') * getValue('high_examination_mix_price')
            + getValue('medium_examination_mix_percent') * getValue('medium_examination_mix_price')
            + getValue('low_examination_mix_percent') * getValue('low_examination_mix_price'));
        selected = (options?.formatValueFunction ? options?.formatValueFunction(value) : value+'') || '';
    }
    if (currency) {
        selected = selected.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className={(!selected ? 'error ' : '') + 'inputValue'}>
            <label htmlFor='rembursement'>Avg reimbursement per exams & medical devices</label>
            <div><span>{currency}</span></div>
            <input id='rembursement'
                   readOnly
                   type="text"
                   value={selected}/>

            {!selected
                ? <small className="msg-error">Need mix to equal 100%</small>
                : ''
            }
        </div>
    );
}
